// utils/videoCallUtils.js
import { NotificationHelper } from '../../../util/notification/NotificationHelper';
import { MedicalEmergencyHelper } from '../../../util/medical-emergency/MedicalEmergencyHelper';
import { Auth } from 'aws-amplify';
import VideocallService from '../../../services/videocall/videocall.service';
import { Mixpanel } from '../../../util/Helper';
import MedicalEmergencyService from '../../../services/medical-emergency/medical-emergency.service';
import { useStore } from '../../../Hooks/useStore';
import { VideoCallNotificationHelper } from '../../../util/notification/VideoCallNotificationHelper';


 // Calling the hook inside the component
export const handleVideoNotificationClick = async (notificationTitle, medicalEmergencyId, flightId, setMedical,rootStore) => {
  //  const { rootStore } = useStore();
  console.log("+++notificationTitle+++", notificationTitle);
  console.log("+++medicalEmergencyId+++", medicalEmergencyId);
  let videoCallInfo;
  if (medicalEmergencyId) {
    setMedical(medicalEmergencyId);
    const videocallRecord =
    await MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
      Number.parseInt(medicalEmergencyId)
    );
    let roomId = videocallRecord.roomId.split(",")[0];
    videoCallInfo = {
      "navigate":"videoCall",
      "flightId": flightId,
      "roomId": roomId,
      "emergencyId": medicalEmergencyId
    }   
  }

  const user = JSON.parse(localStorage.getItem("userinfo"));
  console.log("+++user+++", user);
  const { username, roleLabel } = user;
  console.log("+++username+++", username);
  console.log("+++roleLabel+++", roleLabel);

  const notifyUsers = async (sentBy, messageContent, videoParams) => {
    if (!user || !medicalEmergencyId) return;

    const notificationHelper = new VideoCallNotificationHelper();
    const medicalEmergencyHelper = new MedicalEmergencyHelper();
    let users = [];
    let cognitoUserId = null;

    if (roleLabel.toLowerCase() === "crew") {
      cognitoUserId = await medicalEmergencyHelper.findEms(medicalEmergencyId);
      console.log("+++cognitoUserId 1 +++", cognitoUserId);
    } else {
      cognitoUserId = await medicalEmergencyHelper.findCaptain(flightId);
      console.log("+++ getCaptain +++", cognitoUserId);
      if (cognitoUserId) {
        users.push(cognitoUserId);
      }
      cognitoUserId = await medicalEmergencyHelper.findCrew(medicalEmergencyId);
    }

    if (cognitoUserId) {
      users.push(cognitoUserId);
    }

    if (users.length !== 0) {
      notificationHelper.sendVideoCallNotification(sentBy, messageContent, users, videoParams);
    }
    console.log("+++users+++", users);
  };

  Mixpanel.track("web_video_call_click", { name: username });

  await notifyUsers("Call answered", username ?? "EMS",videoCallInfo);

  try {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken().getJwtToken();
    await VideocallService.initiateVideoCallData(accessToken);
  } catch (e) {
    console.log("Initiate video call access post", e);
  }

  if (notificationTitle.toLowerCase().includes("joined videocall")) {
    const strWindowFeatures = "location=yes,height=570,width=720,scrollbars=yes,status=yes";
    const url = "/call/" + medicalEmergencyId + "/on";
    console.log("+++url+++", url);
    const win = window.open(url, "videocall", strWindowFeatures);
     rootStore.callingStore.handleChildWindowRef(win);
    win?.focus();
  } else {
    console.log("Notification Toast Closed.");
  }
};


export const handleAcceptCallClick = async (medicalEmergencyId, flightId, setMedical,rootStore) => {
  
  console.log("+++audioMedicalEmergencyId+++", medicalEmergencyId);
  console.log("+++audioFlightId+++", flightId);
  let audioCallInfo;
  const [id, name, type, mode] = medicalEmergencyId.split("#");
  console.log("medical id in voice call acceopt", id);
  if (id) {
    setMedical(id);
    const audiocallRecord =
    await MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
      Number.parseInt(id)
    );
    let roomId = audiocallRecord?.roomId.split(",")[0];
    if (roomId) {
      audioCallInfo = {
        "navigate":"videoCall",
        "flightId": flightId,
        "roomId": roomId,
        "emergencyId": id
      }   
    }
  }

  const user = JSON.parse(localStorage.getItem("userinfo"));

  console.log("+++user+++", user);
  const { username, roleLabel } = user;
  console.log("+++username+++", username);
  console.log("+++roleLabel+++", roleLabel);

  const notifyUsers = async (sentBy, messageContent, videoParams) => {
    if (!user || !id) return;

    const notificationHelper = new VideoCallNotificationHelper();
    const medicalEmergencyHelper = new MedicalEmergencyHelper();

    let users = [];
    let cognitoUserId = null;

    if (roleLabel.toLowerCase() === "crew") {
      cognitoUserId = await medicalEmergencyHelper.findEms(id);
      console.log("+++cognitoUserId 1 +++", cognitoUserId);
    } else {
      cognitoUserId = await medicalEmergencyHelper.findCaptain(flightId);
      console.log("+++ getCaptain +++", cognitoUserId);
      if (cognitoUserId) {
        users.push(cognitoUserId);
      }
      cognitoUserId = await medicalEmergencyHelper.findCrew(id);
    }

    if (cognitoUserId) {
      users.push(cognitoUserId);
    }

    if (users.length !== 0) {
      notificationHelper.sendVideoCallNotification(sentBy, messageContent, users, videoParams);
    }
    console.log("+++users+++", users);
  };

  Mixpanel.track("web_audio_call_click", { name: username });

  await notifyUsers("Call initiated", username ?? "EMS",audioCallInfo);

  // try {
  //   const session = await Auth.currentSession();
  //   const accessToken = session.getAccessToken().getJwtToken();
  //   await VideocallService.initiateVideoCallData(accessToken);
  // } catch (e) {
  //   console.log("Initiate video call access post", e);
  // }

    const strWindowFeatures = "location=yes,height=570,width=720,scrollbars=yes,status=yes";
    const url = "/call/" + id + "/" + mode;
    console.log("+++url+++", url);
    const win = window.open(url, "audiocall", strWindowFeatures);
   // localStorage.setItem('aceeptwin', win)
     rootStore.callingStore.handleChildWindowRef(win);
    win?.focus();
};

